import React from 'react';
import './StressViewPanel.css';

export interface ViewGroup {
  viewId: string;
  displayName: string;
  restInstances: { mediaUrl: string; view?: string; stage?: string }[];
  peakInstances: { mediaUrl: string; view?: string; stage?: string }[];
  hasRest: boolean;
  hasPeak: boolean;
}

interface ThumbnailCardProps {
  instance: { mediaUrl: string } | null;
  label: string;
}

const ThumbnailCard: React.FC<ThumbnailCardProps> = ({ instance, label }) => {
  const isVideo = instance?.mediaUrl?.toLowerCase().endsWith('.webm');

  return (
    <div className="svp__thumb-card">
      {instance ? (
        isVideo ? (
          <video
            className="svp__thumb-media"
            src={instance.mediaUrl}
            preload="metadata"
            muted
            playsInline
          />
        ) : (
          <img
            className="svp__thumb-media"
            src={instance.mediaUrl}
            alt={label}
          />
        )
      ) : (
        <div className="svp__thumb-empty">—</div>
      )}
      {isVideo && instance && <div className="svp__play-icon">▶</div>}
      <span className="svp__thumb-label">{label}</span>
    </div>
  );
};

interface StressViewPanelProps {
  viewGroups: ViewGroup[];
  selectedViewId: string;
  onViewSelect: (viewId: string) => void;
  collapsed: boolean;
  onToggleCollapse: () => void;
}

const StressViewPanel: React.FC<StressViewPanelProps> = ({
  viewGroups,
  selectedViewId,
  onViewSelect,
  collapsed,
  onToggleCollapse,
}) => {
  return (
    <div className={`svp__panel ${collapsed ? 'svp__panel--collapsed' : ''}`}>
      <button
        className="svp__toggle-btn"
        onClick={onToggleCollapse}
        title={collapsed ? 'Expand views' : 'Collapse views'}
      >
        {collapsed ? '›' : '‹'}
      </button>

      {!collapsed && (
        <div className="svp__content">
          <div className="svp__header">Views</div>
          <div className="svp__groups">
            {viewGroups.length === 0 && (
              <p className="svp__empty">No views</p>
            )}
            {viewGroups.map(group => {
              const isActive = group.viewId === selectedViewId;
              const restInst = group.restInstances[0] || null;
              const peakInst = group.peakInstances[0] || null;

              return (
                <div
                  key={group.viewId}
                  className={`svp__group ${isActive ? 'svp__group--active' : ''}`}
                  onClick={() => onViewSelect(group.viewId)}
                >
                  <div className="svp__group-title">{group.displayName}</div>
                  <div className="svp__thumb-row">
                    <ThumbnailCard
                      instance={restInst}
                      label="Rest"
                    />
                    <ThumbnailCard
                      instance={peakInst}
                      label="Peak"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default StressViewPanel;
